export const heroTexts = {
    en: {
        values: 'Integrity, Precise, Innovation, Teamwork',
        companyTitle: 'Our Company',
        companyDesc: 'SAMT is a world-leading provider of vacuum furnaces regarding of heat treating and metallurgies, as well as integrated systems for commercial, and R&D.'
    },
    zh: {
        values: '诚信，严谨，创新，团队精神',
        companyTitle: '公司简介',
        companyDesc: 'SAMT先越是一家致力于持续创新的真空炉供应商，专注于热处理和冶金领域，同时为商业化和研发提供集成系统。'
    }
}

export const getHeroTexts = (lang) => {
    return heroTexts[lang] || heroTexts['en']
}